import { render, staticRenderFns } from "./pindaan-g.vue?vue&type=template&id=7cf4f6b1&"
import script from "./pindaan-g.vue?vue&type=script&lang=js&"
export * from "./pindaan-g.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports